import { render, staticRenderFns } from "./ImportOrdersHead.vue?vue&type=template&id=979438a8&scoped=true"
import script from "./ImportOrdersHead.vue?vue&type=script&lang=js"
export * from "./ImportOrdersHead.vue?vue&type=script&lang=js"
import style0 from "./ImportOrdersHead.vue?vue&type=style&index=0&id=979438a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979438a8",
  null
  
)

export default component.exports